<template>
  <div class="my-auto w-100 main-area rss-section">
    <div class="profile-detail">
      <TitleContainer :title="'随時更新：導入企業のキャリア採用情報'" />
      <div class="rss-content">
        <div v-if="loading" class="loading-state">読み込み中...</div>
        <div v-else-if="error" class="error-state">{{ error }}</div>
        <div v-else-if="rssItems.length === 0" class="error-state">記事がありません</div>
        <div v-else class="rss-items">
          <a 
            v-for="(item, index) in rssItems" 
            :key="index"
            :href="item.link"
            target="_blank"
            rel="noopener noreferrer"
            class="rss-item"
          >
            <div class="rss-image">
              <img v-if="item.image" :src="item.image" :alt="item.title" @error="handleImageError" />
              <div v-else class="no-image-placeholder">
                <span>画像なし</span>
              </div>
            </div>
            <div class="rss-details">
              <h3 class="rss-title">{{ item.title }}</h3>
              <div class="rss-meta">
                <span class="rss-author">{{ item.creator }}</span>
                <span class="rss-date">{{ formatDate(item.pubDate) }}</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleContainer from './TitleContainer.vue';
import moment from 'moment';
import Api from '@/config/api';

export default {
  name: 'RssFeed',
  components: {
    TitleContainer,
  },
  data() {
    return {
      rssItems: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    formatDate(dateString) {
      return moment(dateString).format('YYYY年M月D日');
    },
    handleImageError(event) {
      event.target.style.display = 'none';
    },
    async fetchRSS() {
      try {
        this.loading = true;
        const response = await this.axios.get(Api.url(Api.endpoints.rssFeed));
        
        if (response.data && response.data.data) {
          this.rssItems = response.data.data;
        }
        
        this.loading = false;
      } catch (err) {
        this.error = 'RSSフィードの読み込みに失敗しました';
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchRSS();
  },
};
</script>

<style scoped>
.rss-section {
  background-color: #E7F6F6;
  margin-top: 20px;
}

.rss-content {
  padding: 20px;
  background-color: white;
}

.loading-state,
.error-state {
  text-align: center;
  padding: 40px;
  color: #666;
}

.rss-items {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.rss-item {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.rss-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.rss-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  background-color: #f0f0f0;
}

.rss-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e0e0e0;
  color: #999;
  font-size: 14px;
}

.rss-details {
  padding: 15px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.rss-title {
  font-size: 14px;
  font-weight: 600;
  color: #2F2E41;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.rss-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #666;
  margin-top: auto;
}

.rss-author {
  color: #006C6B;
}

.rss-date {
  color: #999;
}

@media (max-width: 768px) {
  .rss-content {
    padding: 15px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
  
  .rss-items {
    display: flex;
    flex-direction: row;
    gap: 15px;
    width: max-content;
  }
  
  .rss-item {
    width: 280px;
    flex-shrink: 0;
  }
  
  .rss-image {
    height: 160px;
  }
  
  .rss-title {
    font-size: 13px;
    line-height: 1.5;
  }
  
  .rss-details {
    padding: 12px;
  }
}

@media (max-width: 530px) {
  .main-area {
    box-shadow: none;
  }
  
  .rss-section {
    background-color: #E7F6F6;
    margin-top: 0;
  }
  
  .rss-content {
    padding: 10px;
    background-color: white;
  }
  
  .rss-items {
    gap: 12px;
  }
  
  .rss-item {
    width: 260px;
    border-radius: 6px;
  }
  
  .rss-image {
    height: 140px;
  }
  
  .rss-title {
    font-size: 12px;
    margin-bottom: 8px;
  }
  
  .rss-meta {
    font-size: 11px;
  }
}
</style>
